// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.security-policies-page {
    min-height: 100vh;
    background: #f5f5f5;
}

.page-header {
    background: white;
    padding: 20px 40px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-header h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
}

.user-info {
    margin: 5px 0 0 0;
    color: #666;
    font-size: 14px;
}

.badge {
    display: inline-block;
    padding: 2px 8px;
    background: #667eea;
    color: white;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin-left: 8px;
    text-transform: uppercase;
}

.header-actions {
    display: flex;
    gap: 10px;
}

.secondary-btn {
    padding: 8px 20px;
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    width: auto;
}

.secondary-btn:hover {
    background: #5a6268;
}

.logout-btn {
    padding: 8px 20px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    width: auto;
}

.logout-btn:hover {
    background: #c82333;
}

.page-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}

.page-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.page-actions h2 {
    margin: 0;
    color: #333;
}

.primary-btn {
    padding: 10px 20px;
    background: #667eea;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    width: auto;
}

.primary-btn:hover {
    background: #5568d3;
}

.error {
    background: #fee;
    color: #c33;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
}

.success {
    background: #d4edda;
    color: #155724;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
}

.loading {
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 16px;
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    background: white;
    border-radius: 10px;
    color: #666;
}

.empty-state p {
    font-size: 16px;
}

.policies-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 20px;
}

.policy-card {
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
}

.policy-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.policy-card-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.policy-card-header h3 {
    margin: 0;
    color: #333;
    font-size: 18px;
    flex: 1 1;
}

.double-side-badge {
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    background: #fff3cd;
    color: #856404;
    margin-left: 10px;
}

.policy-card-body {
    padding: 20px;
}

.info-row {
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.info-row .label {
    font-size: 12px;
    color: #666;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-row .value {
    color: #333;
    font-size: 14px;
}

.info-row .value.enabled {
    color: #28a745;
    font-weight: 600;
}

.info-row .value.disabled {
    color: #6c757d;
}

.policy-card-footer {
    padding: 15px 20px;
    background: #f8f9fa;
    border-top: 1px solid #eee;
    display: flex;
    gap: 10px;
}

.edit-btn {
    flex: 1 1;
    padding: 10px;
    background: #667eea;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.edit-btn:hover {
    background: #5568d3;
}

.delete-btn {
    flex: 1 1;
    padding: 10px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.delete-btn:hover {
    background: #c82333;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    border-radius: 10px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.modal-header {
    padding: 20px 30px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h2 {
    margin: 0;
    color: #333;
    font-size: 20px;
}

.close-btn {
    background: none;
    border: none;
    font-size: 32px;
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    line-height: 1;
}

.close-btn:hover {
    color: #333;
}

.modal-content form {
    padding: 30px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-weight: 600;
    font-size: 14px;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
    outline: none;
    border-color: #667eea;
}

.form-group small {
    display: block;
    margin-top: 4px;
    color: #666;
    font-size: 12px;
}

.checkbox-group {
    margin-bottom: 20px;
}

.checkbox-group label {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    font-weight: 600;
    color: #555;
}

.checkbox-group input[type="checkbox"] {
    width: auto;
    margin: 2px 12px 0 0;
    cursor: pointer;
}

.checkbox-group span {
    flex: 1 1;
}

.checkbox-group small {
    display: block;
    margin-top: 8px;
    margin-left: 32px;
    color: #666;
    font-size: 12px;
    font-weight: normal;
}

.modal-footer {
    padding: 20px 30px;
    border-top: 1px solid #eee;
    display: flex;
    gap: 10px;
    background: #f8f9fa;
}

.modal-footer button {
    flex: 1 1;
    padding: 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SecurityPolicies.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".security-policies-page {\n    min-height: 100vh;\n    background: #f5f5f5;\n}\n\n.page-header {\n    background: white;\n    padding: 20px 40px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.page-header h1 {\n    margin: 0;\n    color: #333;\n    font-size: 24px;\n}\n\n.user-info {\n    margin: 5px 0 0 0;\n    color: #666;\n    font-size: 14px;\n}\n\n.badge {\n    display: inline-block;\n    padding: 2px 8px;\n    background: #667eea;\n    color: white;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    margin-left: 8px;\n    text-transform: uppercase;\n}\n\n.header-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.secondary-btn {\n    padding: 8px 20px;\n    background: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    width: auto;\n}\n\n.secondary-btn:hover {\n    background: #5a6268;\n}\n\n.logout-btn {\n    padding: 8px 20px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    width: auto;\n}\n\n.logout-btn:hover {\n    background: #c82333;\n}\n\n.page-content {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 20px;\n}\n\n.page-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.page-actions h2 {\n    margin: 0;\n    color: #333;\n}\n\n.primary-btn {\n    padding: 10px 20px;\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    width: auto;\n}\n\n.primary-btn:hover {\n    background: #5568d3;\n}\n\n.error {\n    background: #fee;\n    color: #c33;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.success {\n    background: #d4edda;\n    color: #155724;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.loading {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n    font-size: 16px;\n}\n\n.empty-state {\n    text-align: center;\n    padding: 60px 20px;\n    background: white;\n    border-radius: 10px;\n    color: #666;\n}\n\n.empty-state p {\n    font-size: 16px;\n}\n\n.policies-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n    gap: 20px;\n}\n\n.policy-card {\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.policy-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.policy-card-header {\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.policy-card-header h3 {\n    margin: 0;\n    color: #333;\n    font-size: 18px;\n    flex: 1;\n}\n\n.double-side-badge {\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n    background: #fff3cd;\n    color: #856404;\n    margin-left: 10px;\n}\n\n.policy-card-body {\n    padding: 20px;\n}\n\n.info-row {\n    margin-bottom: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.info-row .label {\n    font-size: 12px;\n    color: #666;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.info-row .value {\n    color: #333;\n    font-size: 14px;\n}\n\n.info-row .value.enabled {\n    color: #28a745;\n    font-weight: 600;\n}\n\n.info-row .value.disabled {\n    color: #6c757d;\n}\n\n.policy-card-footer {\n    padding: 15px 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #eee;\n    display: flex;\n    gap: 10px;\n}\n\n.edit-btn {\n    flex: 1;\n    padding: 10px;\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.edit-btn:hover {\n    background: #5568d3;\n}\n\n.delete-btn {\n    flex: 1;\n    padding: 10px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.delete-btn:hover {\n    background: #c82333;\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 10px;\n    width: 90%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n    padding: 20px 30px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal-header h2 {\n    margin: 0;\n    color: #333;\n    font-size: 20px;\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    font-size: 32px;\n    color: #999;\n    cursor: pointer;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    line-height: 1;\n}\n\n.close-btn:hover {\n    color: #333;\n}\n\n.modal-content form {\n    padding: 30px;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #555;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n    outline: none;\n    border-color: #667eea;\n}\n\n.form-group small {\n    display: block;\n    margin-top: 4px;\n    color: #666;\n    font-size: 12px;\n}\n\n.checkbox-group {\n    margin-bottom: 20px;\n}\n\n.checkbox-group label {\n    display: flex;\n    align-items: flex-start;\n    cursor: pointer;\n    font-weight: 600;\n    color: #555;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n    width: auto;\n    margin: 2px 12px 0 0;\n    cursor: pointer;\n}\n\n.checkbox-group span {\n    flex: 1;\n}\n\n.checkbox-group small {\n    display: block;\n    margin-top: 8px;\n    margin-left: 32px;\n    color: #666;\n    font-size: 12px;\n    font-weight: normal;\n}\n\n.modal-footer {\n    padding: 20px 30px;\n    border-top: 1px solid #eee;\n    display: flex;\n    gap: 10px;\n    background: #f8f9fa;\n}\n\n.modal-footer button {\n    flex: 1;\n    padding: 10px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
